var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-layout"},[_c('div',{staticClass:"app-layout__body",attrs:{"data-theme":_vm.theme}},[_c('div',{staticClass:"app-layout__wrapper"},[_c('VAppMain',{staticClass:"app-layout__row app-layout__row_main"},[_vm._t("default")],2)],1),_c('VSnowfall',{attrs:{"isSnowEnabled":_vm.isSnowEnabled}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }